import React from 'react'
import './DesktopModal.css'
import Close from 'SVGPath/close.svg'

const DesktopModal = ({ content = null, children = null, header, showFlag, onCloseModal }) => {
  const closeModal = e => {
    e.stopPropagation()
    e.preventDefault()
    onCloseModal()
  }
  return (
    <div className={showFlag ? 'desktop-modal' : 'hide'}>
      <div className="desktop-modal-container">
        <div className="flex flex-between flex-middle ta-center desktop-modal-header">
          <h1 className="flex-1 fs-16 fw-700 p-2">{header}</h1>
          <span className="desktop-modal-close" onClick={closeModal}><Close fill="#666" /></span>
        </div>
        <If condition={content || children}>
          <div className="desktop-modal-body">{content || children}</div>
        </If>
      </div>
    </div>
  )
}

export default DesktopModal
